module.exports = __webpack_public_path__ + "files/ab9bc8f43c9478c770edb5f783751920.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/people-3.png
// module id = 1456
// module chunks = 60